class ImperiaFooterDisclosure extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;

    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    if (!this.details || !this.summary) return;

    this.dataset.ready = 'true';
    this.details.addEventListener('toggle', this.syncExpandedState);
    this.syncExpandedState();
  }

  disconnectedCallback() {
    this.details?.removeEventListener('toggle', this.syncExpandedState);
  }

  syncExpandedState = () => {
    this.summary?.setAttribute('aria-expanded', String(this.details?.open === true));
  };
}

if (!customElements.get('imperia-footer-disclosure')) {
  customElements.define('imperia-footer-disclosure', ImperiaFooterDisclosure);
}
